import { Component, OnInit } from '@angular/core';
import * as feather from 'feather-icons';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    feather.replace();
  }

  toggleMenu(event){
    if(event.srcElement.localName.includes('svg')){
      if (event.srcElement.nextElementSibling.className == 'hamburger-details dis-none') {
        event.srcElement.nextElementSibling.className = 'hamburger-details dis-block';
      }
      else {
        event.srcElement.nextElementSibling.className = 'hamburger-details dis-none';
      }
    }
    else if(event.srcElement.localName.includes('line')){
      if (event.srcElement.parentElement.nextElementSibling.className == 'hamburger-details dis-none') {
        event.srcElement.parentElement.nextElementSibling.className = 'hamburger-details dis-block';
      }
      else {
        event.srcElement.parentElement.nextElementSibling.className = 'hamburger-details dis-none';
      }
    }
  }

  dismiss(){
    document.getElementsByClassName('hamburger-details')[0].className = "hamburger-details dis-none";
  }

}
